<app-str-spinner [message]="spinnerMessage"></app-str-spinner>
<div class="tds-u-pt1">
    <div class="tds-row">
        <div class="tds-col-xxlg-2 tds-col-xlg-3 tds-col-lg-3 tds-col-md-4 tds-col-sm-4 tds-col-xs-12 ">
            <tds-datetime 
                type="date"    
                size="sm" 
                class="tds-u-mb1"
                label="Visible from date" 
                [(ngModel)]="fromDate"  
                ngDefaultControl
                value="{{fromDate}}" 
                min="2023-01-01">
            </tds-datetime> 
        </div>
        <div class="tds-col-xxlg-2 tds-col-xlg-3 tds-col-lg-3 tds-col-md-4 tds-col-sm-4 tds-col-xs-12 tds-u-mb1">
            <tds-datetime 
                type="date"    
                size="sm" 
                class="tds-u-mb1"
                label="Visible to date"
                [(ngModel)]="toDate"  
                ngDefaultControl
                value="{{toDate}}" 
                min="2023-01-01">
            </tds-datetime> 
        </div>
        <div class="tds-col-xxlg-2 tds-col-xlg-3 tds-col-lg-3 tds-col-md-4 tds-col-sm-4 tds-col-xs-12 tds-u-mb1">
            <tds-dropdown 
                name="dropdown" 
                label="Period" 
                label-position="outside" 
                placeholder="Select Message Type" 
                size="sm" 
                class="tds-u-mb1"
                default-value="1"
                open-direction="auto"> 
                <tds-dropdown-option value="1" (click)="urgency='1'">1 - Maintenance messages</tds-dropdown-option> 
                <tds-dropdown-option value="2" (click)="urgency='2'">2 - Educational</tds-dropdown-option> 
                <tds-dropdown-option value="3" (click)="urgency='3'">3 - Other info</tds-dropdown-option> 
            </tds-dropdown>

        </div>
    </div>
    <div class="tds-row tds-u-mb1">
        <div class="tds-col-xxlg-6 tds-col-xlg-9 tds-col-lg-9 tds-col-md-12 tds-col-sm-12 tds-col-xs-12">
            <tds-text-field
                type="text" 
                label="Header text" 
                ngDefaultControl
                [(ngModel)]="headerText"  
                label-position="outside"
                placeholder="Enter text here" ></tds-text-field> 
        </div>
    </div>    
    <div class="tds-row tds-u-mb1">
        <div class="tds-col-xxlg-6 tds-col-xlg-9 tds-col-lg-9 tds-col-md-12 tds-col-sm-12 tds-col-xs-12">
            <tds-textarea 
                rows="3" 
                label="Message text" 
                ngDefaultControl
                [(ngModel)]="infoMsg"  
                label-position="outside"
                placeholder="Enter text here" ></tds-textarea> 
        </div>
    </div>
    <div class="tds-row ">
        <div class="tds-col-xxlg-6 tds-col-xlg-9 tds-col-lg-9 tds-col-md-12 tds-col-sm-12 tds-col-xs-12">
            <tds-button [disabled]="isSaveDisabled()"  type="button" variant="primary" size="sm" text="Save" (click)="submitData()"> 
                <tds-icon slot="icon" size="20px" name="save"></tds-icon> 
            </tds-button> 
        </div>
    </div>
</div>

<div class="tds-u-p2">
    <tds-table vertical-dividers="false" 
        compact-design="false" 
        responsive="true" 
        no-min-width >
        <tds-table-header >
            <tds-header-cell cell-value="From Date"></tds-header-cell>
            <tds-header-cell cell-value="To Date"></tds-header-cell>
            <tds-header-cell cell-value="Message Type"></tds-header-cell>
            <tds-header-cell cell-value="Header"></tds-header-cell>
            <tds-header-cell cell-value="Message"></tds-header-cell>
            <tds-header-cell cell-value="Status" > </tds-header-cell>
            <tds-header-cell cell-value="Delete Message" > </tds-header-cell>
        </tds-table-header>

        <tds-table-body >
            <tds-table-body-row *ngFor="let msg of infoMessages">
                <tds-body-cell>
                    <div class="tds-u-pt2" style="white-space: nowrap;">
                        {{ msg.activateDate | date:'EEEE, yyyy-MM-dd' }}
                    </div>
                </tds-body-cell>

                <tds-body-cell>
                    <div class="tds-u-pt2"  style="white-space: nowrap;">
                        {{ msg.deActivateDate | date:'EEEE, yyyy-MM-dd' }}
                    </div>
                </tds-body-cell>

                <tds-body-cell>
                    <div class="tds-u-pt2">
                        {{ getMessageTypeText(msg.importance) }}
                    </div>
                </tds-body-cell>

                <tds-body-cell>
                    <div class="tds-u-pt2" style="min-width: 250px;">
                        {{ msg.header }}
                    </div>
                </tds-body-cell>

                <tds-body-cell>
                    <div class="tds-u-pt2" style="min-width: 300px;">
                        {{ msg.message }}
                    </div>
                </tds-body-cell>
                
                <tds-body-cell>
                    <div *ngIf="isActive(msg.activateDate)" class="tds-u-pt2" style="color: green;">
                        Active
                    </div>

                    <div *ngIf= "!isActive(msg.activateDate)" class="tds-u-pt2" style="color: blue;">
                        Scheduled
                    </div>
                </tds-body-cell> 

                <tds-body-cell>
                    <div  style="min-width: 130px;">
                        <tds-button type="button" variant="primary" variant="danger" size="sm" text="Delete"  (click)="deleteMessage(msg.id)"> 
                            <tds-icon slot="icon" size="20px" name="trash"></tds-icon> 
                        </tds-button> 
                    </div>
                </tds-body-cell>

            </tds-table-body-row>
        </tds-table-body >
    </tds-table>
<div>
        
